<template>
   <!--Page alert + loader-->
   <PageStatus :alert="defaultAlert" :table-data="tableData" />

<!--Plan/Package Modal-->
   <div id="planModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
         <!-- Modal content-->
         <div class="modal-content bg-sa-modal-content">
            <div class="modal-header bg-sa-modal-header">
               <h4 class="modal-title sa-core-color w-100 text-center">Update Plan/Package Modal</h4>
               <button type="button" class="btn-close color-sa-btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
               <!--AlertMessage -->
               <AlertComponent v-if="defaultAlert.pageOrModal=='modal'" :alertstatus="defaultAlert.alertstatus" :message="defaultAlert.alertMessage" :type="defaultAlert.alertType"  />
               <!--End AlertMessage -->
               <form id="updatePlanForm">
                  <HiddenField v-model="formInputs.id" />

                  <div class="row g-3 mb-3">
                     <!-- The plan (an option object: { id, subscription_package }). id 0 = Remove Subscription -->
                     <SelectField
                        v-model="formInputs.subscription_package"
                        col="col-12"
                        name="subscription_package"
                        label="Select Plan"
                        icon="fa fa-cube"
                        :options="planChoices"
                        option-label="subscription_package"
                        placeholder="Select..."
                        tooltip="Please choose a plan"
                        required
                        @change="$clearValidationAlert('#updatePlanForm')"
                     />

                     <!-- Not needed when removing the subscription -->
                     <SelectField
                        v-if="Number(formInputs.subscription_package?.id) !== 0"
                        v-model="formInputs.subscription_period"
                        col="col-12"
                        name="subscription_period"
                        label="Select Subscription Period"
                        icon="fa fa-refresh"
                        :options="speriodOptions"
                        :reduce="option => option.value"
                        placeholder="Select..."
                        tooltip="Please choose Monthly, Quarterly or Yearly"
                        required
                        @change="$clearValidationAlert('#updatePlanForm')"
                     />
                  </div>

                  <button @click="updatePlan()" class="btn btn-primary" type="button">Update Plan</button>
               </form>
            </div>
            <div class="modal-footer bg-sa-modal-footer">
               <button type="button" class="btn btn-default modal_close color-sa-modal_close" data-bs-dismiss="modal">Close</button>
            </div>
         </div>
         <!--End Modal content-->
      </div>
   </div>
   <!--Plan/Package Modal-->

      <!--Filter Data Modal (shared: FilterModal.vue)-->
   <FilterModal
      :draft="filterDraft"
      v-model:search-by="tableData.searchBy"
      :view-options="viewOptions"
      :search-by-options="searchByOptions"
      :alert="defaultAlert"
      @search-by-change="changePlaceholder()"
      @apply="applyFilters"
      @clear="clearFilters"
   />
   <!--End Filter Data Modal-->

   <h4 class="sa-core-color fw-semibold mb-2 d-flex align-items-center flex-wrap gap-2">
      <span><i :class="[pageIcon, 'me-2 opacity-75']"></i>{{ pageTitle }}</span>
      <span class="badge rounded-pill border fs-6 fw-normal sa-theme-pill" title="Clients logged in right now">
         <i class="fa fa-circle online-dot me-1"></i>{{ tableData.clientsOnline.online }} of {{ tableData.clientsOnline.total }} clients online
      </span>
   </h4>
   <!--Tables-->
   <div class="card glass mt-0 bg-sa-card">
      <div class="card-body bg-sa-card-body p-0">

                  <!-- Table action row (shared: TableToolbar.vue). No Add: clients sign up themselves -->
         <TableToolbar
            :filter-count="activeFilterCount"
            :columns="tableColumns"
            v-model:hidden-columns="hiddenColumns"
            :selected-count="tableData.selectedRecordIds.length"
            :can-delete="false"
            @filter="openFilters"
            @clear-selection="clearSelection"
         >
            <!-- More menu -->
            <template #more>
               <li><h6 class="dropdown-header">Data</h6></li>
               <li>
                  <button type="button" class="dropdown-item" @click="exportRecords('xls')">
                     <i class="fa fa-file-excel-o fa-fw me-1 text-success"></i> Export to Excel
                  </button>
               </li>
               <li>
                  <button type="button" class="dropdown-item" @click="exportRecords('csv')">
                     <i class="fa fa-file-text-o fa-fw me-1 text-success"></i> Export to CSV
                  </button>
               </li>
               <li>
                  <button type="button" class="dropdown-item" @click="exportRecords('pdf')">
                     <i class="fa fa-file-pdf-o fa-fw me-1 text-danger"></i> Export to PDF
                  </button>
               </li>
            </template>
         </TableToolbar>
         <!-- Table Search Panel -->
         <SearchBox
            v-model:search-query="tableData.searchQuery"
            v-model:records-per-page="tableData.recordsPerPage"
            :placeholder="tableData.searchPlaceHolderText"
            @search-input="onSearchInput"
            @search-click="onSearchButtonClick"
            @per-page-change="onRecordsPerPageChange"
         />
         <!-- What the table is currently showing -->
         <ActiveFilters
            :chips="activeFilterChips"
            @remove="removeFilterChip"
            @clear="clearAllFilterChips"
         />


         <!-- Table -->
         <div class="table-responsive">
            
            <table
    class="table table-hover align-middle mb-0"
    id="bootstrapTable"
    tabindex="0"
    @keydown.up="$moveRowSelection(-1, $event)"
    @keydown.down="$moveRowSelection(1, $event)"
    @keydown.enter="$onTableEnter($event)"
>
      <thead>
      <tr>
         <th>
            <input type="checkbox" v-model="tableData.selectAll" @change="toggleSelectAll" />
         </th>
         <th class="hide-sm-td"><span class="visually-hidden">Details</span></th>
         <th class="button hide-sm-td">No</th>
         <SortableTh v-if="isColumnVisible('first_name')" column="first_name" :table-data="tableData" @sort="orderBy">Client</SortableTh>
         <th v-if="isColumnVisible('company_name')" class="hide-sm-td">Company</th>
         <th v-if="isColumnVisible('country')" class="hide-sm-td">Country</th>
         <SortableTh v-if="isColumnVisible('email')" column="email" :table-data="tableData" @sort="orderBy" class="hide-sm-td">Email</SortableTh>
         <th v-if="isColumnVisible('package')" class="hide-sm-td">Package</th>
         <th v-if="isColumnVisible('cost')" class="hide-sm-td">Cost</th>
         <th v-if="isColumnVisible('status')" class="hide-sm-td">Status</th>
         <th v-if="isColumnVisible('online')" class="hide-sm-td">Online</th>
         <th class="button">Action</th>
      </tr>
   </thead>

   <tbody>
      <template v-for="(record, index) in tableData.records" :key="record.id">
         <!-- Main row -->
         <tr class="clickable-row"
             :data-record-id="record.id"
             :class="{ 'active-row main-row': tableData.selectedRecordId === record.id, 'row-just-saved': isJustSaved(record) }"
             @click="$onRowClick(record, $event)"
         >
            <td>
               <input type="checkbox" v-model="tableData.selectedRecordIds" :value="record.id" />
            </td>
            <td class="expand-cell hide-sm-td"
                :aria-expanded="expandedRows[record.id] ? 'true' : 'false'"
                @click="$toggleDetails(record.id)">
               <i class="fa fa-lg expand-icon ms-1"
                  :class="expandedRows[record.id] ? 'fa-minus-circle text-danger' : 'fa-plus-circle sa-core-color'"
                  :style="expandedRows[record.id] ? null : { color: 'inherit' }"></i>
            </td>
            <td class="hide-sm-td">{{ (tableData.currentPage - 1) * tableData.recordsPerPage + index + 1 }}</td>
            <td v-if="isColumnVisible('first_name')">
               <!-- Phones: + / − and the number go in front of the client (their columns are hidden) -->
               <span
                  class="show-sm-inline expand-cell me-2"
                  :aria-expanded="expandedRows[record.id] ? 'true' : 'false'"
                  @click="$toggleDetails(record.id)"
               >
                  <i class="fa fa-lg expand-icon"
                     :class="expandedRows[record.id] ? 'fa-minus-circle text-danger' : 'fa-plus-circle sa-core-color'"
                     :style="expandedRows[record.id] ? null : { color: 'inherit' }"></i>
               </span>
               <span class="show-sm-inline">{{ (tableData.currentPage - 1) * tableData.recordsPerPage + index + 1 }}. </span>
               <img v-if="record.file_path" :src="`${$baseUrl}/users/${record.file_path}`" height="24" width="24" class="rounded-circle me-1 object-fit-cover" />
               {{ getFullName(record) }}
            </td>
            <td v-if="isColumnVisible('company_name')" class="hide-sm-td">{{ record.company_name }}</td>
            <td v-if="isColumnVisible('country')" class="hide-sm-td text-nowrap">
               <span v-if="record.country" class="me-1">{{ $getFlag(record.country) }}</span>{{ $getCountryName(record.country) }}
            </td>
            <td v-if="isColumnVisible('email')" class="hide-sm-td">{{ record.email }}</td>
            <td v-if="isColumnVisible('package')" class="hide-sm-td">{{ record.subscription_package_name ?? 'No Plan Yet' }}</td>
            <td v-if="isColumnVisible('cost')" class="hide-sm-td text-nowrap">{{ record.subscription_price_c != null ? $formatMoney(record.subscription_price_c, record.subscription_currency) : '-' }}</td>
            <td v-if="isColumnVisible('status')" class="hide-sm-td">
               <span :class="getStatusClass(record)">
                  {{ formatSubscriptionStatus(record) }}
               </span>
            </td>
            <td v-if="isColumnVisible('online')" class="hide-sm-td text-nowrap" :title="record.last_login_at ? 'Last login: ' + $ConvertToLocalDate(record.last_login_at) : 'Never logged in'">
               <i class="fa fa-circle me-1" :class="Number(record.is_loggedIn) === 1 ? 'online-dot' : 'text-secondary'"></i>{{ Number(record.is_loggedIn) === 1 ? 'Online' : 'Offline' }}
            </td>
            <td>
               <div class="d-flex justify-content-end align-items-center w-100 flex-wrap">
                  <div class="btn-group">
                     <!-- Computers: "Actions ▾". Phones: ⋮ only (app-table.css: .row-actions-btn) -->
                     <button type="button" class="btn btn-secondary dropdown-toggle row-actions-btn" data-bs-toggle="dropdown" aria-label="Actions">
                        <i class="fa fa-ellipsis-v d-md-none"></i><span class="d-none d-md-inline">Actions</span>
                     </button>
                     <ul class="dropdown-menu dropdown-menu-end actions-menu">
                        <li>
                           <button type="button" @click="setUpdatePlanFormId(record)" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#planModal">
                              <i class="fa fa-credit-card me-1 text-primary"></i> Edit Plan
                           </button>
                        </li>
                        <li>
                           <button type="button" class="dropdown-item" @click="$toggleRecordDetails(record.id)">
                              <i class="fa fa-eye me-1 text-info"></i> View
                           </button>
                        </li>
                     </ul>
                  </div>
               </div>
            </td>
         </tr>

         <!-- Hidden expanded row -->
         <tr class="collapse-row">
            <td class="p-0"></td>
            <td class="p-0 hide-sm-td"></td>
            <td colspan="10" class="p-0">
               <div :id="'tableDetails' + record.id" class="collapse table-collapse table-details">
                  <div class="p-3 details-list">
                     <div><i class="fa fa-hashtag"></i><strong>Client Number:</strong> {{ record.user_number }}</div>
                     <div><i class="fa fa-sitemap"></i><strong>Branch:</strong> {{ record.branch_name }}</div>

                     <!-- Shown on phones, or always when the column is hidden (Columns button) -->
                     <div :class="{ 'show-sm-td': isColumnVisible('first_name') }"><i class="fa fa-user"></i><strong>Client:</strong> {{ getFullName(record) }}</div>
                     <div :class="{ 'show-sm-td': isColumnVisible('company_name') }"><i class="fa fa-building"></i><strong>Company:</strong> {{ record.company_name }}</div>
                     <div :class="{ 'show-sm-td': isColumnVisible('country') }"><i class="fa fa-globe"></i><strong>Country:</strong>
                        <span v-if="record.country" class="me-1">{{ $getFlag(record.country) }}</span>{{ $getCountryName(record.country) }}
                     </div>
                     <div :class="{ 'show-sm-td': isColumnVisible('email') }"><i class="fa fa-envelope"></i><strong>Email:</strong> {{ record.email }}</div>
                     <div :class="{ 'show-sm-td': isColumnVisible('package') }"><i class="fa fa-cube"></i><strong>Package:</strong> {{ record.subscription_package_name ?? 'No Plan Yet' }}</div>
                     <div :class="{ 'show-sm-td': isColumnVisible('cost') }"><i class="fa fa-tag"></i><strong>Cost:</strong> {{ record.subscription_price_c != null ? $formatMoney(record.subscription_price_c, record.subscription_currency) : '-' }}</div>
                     <div :class="{ 'show-sm-td': isColumnVisible('status') }"><i class="fa fa-check-circle"></i><strong>Status:</strong>
                        <span :class="getStatusClass(record)">{{ formatSubscriptionStatus(record) }}</span>
                     </div>

                     <!-- Always in details -->
                     <div><i class="fa fa-phone"></i><strong>Phone:</strong> {{ record.phone }}</div>
                     <div><i class="fa fa-id-badge"></i><strong>Username:</strong> {{ record.username }}</div>
                     <div><i class="fa fa-refresh"></i><strong>Subscription Period:</strong> {{ formatPeriod(record.subscription_period) }}</div>
                     <div><i class="fa fa-calendar"></i><strong>Subscription Start:</strong> {{ $ConvertToLocalDate(record.subscription_start_date) }}</div>
                     <div><i class="fa fa-calendar-times-o"></i><strong>Subscription End:</strong> {{ $ConvertToLocalDate(record.subscription_end_date) }}</div>
                     <div><i class="fa fa-hourglass-half"></i><strong>Remaining Days:</strong> {{ formatRemainingDays(record.remaining_days) }}</div>
                     <div v-if="$hasPermission('view-location')"><i class="fa fa-map-marker"></i><strong>Registered From:</strong> {{ record.current_location }}</div>
                     <div><i class="fa fa-shield"></i><strong>MFA:</strong> {{ getEnabledLabel(record.mfa_enabled) }}</div>
                     <div><i class="fa fa-power-off"></i><strong>Account:</strong> {{ Number(record.is_active) === 1 ? 'Active' : 'Inactive' }}</div>
                     <div :class="{ 'show-sm-td': isColumnVisible('online') }"><i class="fa fa-circle" :class="Number(record.is_loggedIn) === 1 ? 'online-dot' : 'text-secondary'"></i><strong>Online:</strong>
                        {{ Number(record.is_loggedIn) === 1 ? 'Yes' : 'No' }}
                        <span v-if="record.last_login_at" class="text-muted">· last login {{ $ConvertToLocalDate(record.last_login_at) }}</span>
                     </div>
                     <div><i class="fa fa-edit"></i><strong>Updated By:</strong> {{ record.updatedby_firstname }}</div>
                     <div><i class="fa fa-calendar"></i><strong>Registered On:</strong> {{ $ConvertToLocalDate(record.date_created) }}</div>
                     <div><i class="fa fa-calendar"></i><strong>Date Updated:</strong> {{ $ConvertToLocalDate(record.date_updated) }}</div>
                     <div v-if="$hasPermission('view-ip-address')"><i class="fa fa-desktop"></i><strong>IP Address:</strong> {{ record.ip_address }}</div>
                  </div>
               </div>
            </td>
         </tr>
      </template>

      <!-- Total cost of active subscriptions -->
      <tr v-if="tableData.records.length > 0">
         <td colspan="12" class="text-end fw-bold">Total (active subscriptions, per month): {{ tableData.totalCost }}</td>
      </tr>

      <!-- No rows: blank while loading, then the empty message in the middle (no Add: clients sign up themselves) -->
      <tr v-if="tableData.records.length === 0" class="table-filler">
         <td colspan="12" class="text-center align-middle" :style="{ height: fullPageHeight() }">
            <TableEmptyState
               v-if="!tableLoading"
               :has-filters="activeFilterCount > 0 || !!tableData.appliedSearchQuery"
               :title="activeFilterCount > 0 || tableData.appliedSearchQuery ? '' : 'No clients yet'"
               :message="activeFilterCount > 0 || tableData.appliedSearchQuery ? '' : 'Clients appear here when they sign up.'"
               icon="fa fa-users"
               @clear="clearAllFilterChips"
            />
         </td>
      </tr>
   </tbody>

   <tfoot class="table-light">
      <tr>
         <td colspan="12">
            <!-- Pagination (hidden when there are no rows; its space is kept) -->
            <div v-if="tableData.records.length === 0 && tableData.currentPage <= 1" class="pagination-placeholder"></div>
            <Pagination
               v-else
               :currentPage="tableData.currentPage"
               :totalPages="tableData.totalPages"
               :hasNextPage="tableData.hasNextPage"
               :totalRecords="tableData.totalRecords"
               :startRecord="tableData.startRecord"
               :endRecord="tableData.endRecord"
               :showFullPagination="tableData.totalRecords > 0"
               :lastKnownPage="lastKnownPage"
               @page-changed="fetchRecords"
               @loaderMessage="updateLoaderMessage"
               @last-page-request="goToLastPage"
            />
         </td>
      </tr>
   </tfoot>
</table>

                     

         </div>         
      </div>
   </div>
   <!--End Tables-->
</template>
<script>
import SelectField from "../../../components/admin/SelectField.vue";
import HiddenField from "../../../components/admin/HiddenField.vue";

import AlertComponent from '../../../components/ui/AlertComponent.vue'
import PageStatus from "../../../components/admin/PageStatus.vue";
import TableToolbar from "../../../components/admin/TableToolbar.vue";
import FilterModal from "../../../components/admin/FilterModal.vue";
import ActiveFilters from "../../../components/admin/ActiveFilters.vue";
import SearchBox from "../../../components/admin/SearchBox.vue";
import Pagination from "../../../components/admin/Pagination.vue";
import TableEmptyState from "../../../components/admin/TableEmptyState.vue";
import SortableTh from "../../../components/admin/SortableTh.vue";
import clientsMixin from "./mixins/clientsMixin.js";
import tableMixin from "../../../mixins/tableMixin.js";
import axios from 'axios';


export default {
   name: 'Clients',
   mixins: [tableMixin, clientsMixin], // shared table methods first, then Clients' own
   components: {
      SelectField,
      HiddenField,
      AlertComponent,
      PageStatus,
      TableToolbar,
      FilterModal,
      ActiveFilters,
      SearchBox,
      Pagination,
      TableEmptyState,
      SortableTh,
   },
      data() {
      return {
         // Standard data (tableData, defaultAlert ...) comes from tableMixin
         apiUrl: "/clients/api_clients.php", // used by tableMixin's fetchRecords, delete, export
         exportFileName: "clientsExport",    // name of the exported file
         columnsKey: "clients",              // saves this page's hidden columns (Columns button)
         formInputs: this.getDefaultFormInputs(),
         plansOptions: [],
         pageIcon: 'fa fa-users', // same icon as this page in the sidebar
         speriodOptions: [
            { label: "Monthly", value: 1 },
            { label: "Quarterly", value: 3 },
            { label: "Yearly", value: 12 }
         ],
         // Filter window: View
         viewOptions: [
            { label: "All Records", value: "all" },
            { label: "Records By Me", value: "byme" },
            { label: "Records Deleted", value: "deletedone" },
         ],
         // Filter window: Search By
         searchByOptions: [
            { label: "First Name", value: "first_name" },
            { label: "Last Name", value: "last_name" },
            { label: "Email", value: "email" },
            { label: "Phone", value: "phone" },
            { label: "Username", value: "username" },
         ],
      };
   },
   mounted(){
      this.fetchPlansOptions(); // plans for the Edit Plan window
   },

   async created() {      
      //alert(this.$store.state.isLoggedIn);
      //this.retriveUserDetails();           
      await this.fetchRecords(
                this.tableData.currentPage,
                this.tableData.currentSortColumn,
                "DESC",
                this.tableData.startDate,
                this.tableData.endDate,
                this.$loaderMessages.loaderMessageDefault,
            );
      this.$checkIfCanFetchLocation();//Only applies if location is enabled for user. If not Log user out for him to enable location 
   },
   computed: {
       // Page heading that follows the chosen filter.
       pageTitle() {
           const titles = {
               all: "Clients",
               byme: "Clients By Me",
               deletedone: "Clients Deleted Records",
           };
           return titles[this.tableData.recordFilter] || "Clients";
       },
       // Plans plus "Remove Subscription" (id 0)
      planChoices() {
         return [{ id: 0, subscription_package: 'Remove Subscription' }, ...this.plansOptions];
      },
      // Columns the user can show or hide (Columns button)
      tableColumns() {
         return [
            { key: "first_name", label: "Client" },
            { key: "company_name", label: "Company" },
            { key: "country", label: "Country" },
            { key: "email", label: "Email" },
            { key: "package", label: "Package" },
            { key: "cost", label: "Cost" },
            { key: "status", label: "Status" },
            { key: "online", label: "Online" },
         ];
      },
   },
   methods: {    
      // "none" | "active" | "expired", using the status AND the end date
      planState(record) {
         if (!record.subscription_package) return "none";
         if (Number(record.subscription_status) !== 1) return "expired";
         if (record.remaining_days !== null && record.remaining_days !== undefined && record.remaining_days < 0) return "expired";
         return "active";
      },
      formatSubscriptionStatus(record) {
         return { none: "No Plan", active: "Active", expired: "Expired" }[this.planState(record)];
      },
      getStatusClass(record) {
         return { none: "badge bg-secondary", active: "badge bg-success", expired: "badge bg-danger" }[this.planState(record)];
      },
      getFullName(record) {
         return [record.first_name, record.middle_name, record.last_name].filter(Boolean).join(" ");
      },
      getEnabledLabel(value) {
         return Number(value) === 1 ? "Enabled" : "Disabled";
      },
      formatRemainingDays(days) {
         if (days === null || days === undefined) return "-";
         return days < 0 ? `Expired ${Math.abs(days)} days ago` : `${days} days`;
      },
      formatPeriod(value) {
         const map = {
           1: 'Monthly',
           3: 'Quarterly',
           12: 'Yearly'
         };
         return map[value] || value;
      },  
      fetchPlansOptions(){
         let url = `${this.apiUrl}?action=fetchPlans`;

         axios.get(url,this.$handleConfig())
            .then((response) => {
               if (response.data.status=="success") {
                  this.handleFetchPlansSuccess(response);
               } else {
                  this.handleAlert("starting",response.data.message,"danger","page");
               }
            })
            .catch((error) => {
               if (error.message === 'Network Error') {
                  this.handleAlert("ending","No internet connection. Please check your network.","danger","page");
                } else {
                  this.handleAlert("ending","Something went wrong. Please try again later.","danger","page");
                }
               
            });
      },
      getDefaultFormInputs(){
         return {
            //Form Data
            id: "",
            first_name: "",
            middle_name: "",
            last_name: "",
            phonenumber: "",
            gender: "",
            role: "",
            subscription_package: "",
            subscription_period: "",
            date_of_birth: "",
            email: "",
            username: "",
            mfa_enabled: "",
            is_locationRequired: "",
            is_active: "",
            password: "",
            confirm_password: "",
            crudImage: "",
            select_drop_down: [],
            file: null,
         };
      },
            // Table defaults: the standard ones (tableMixin) + this page's own
      getDefaultTableData(){
         return {
            ...this.baseTableData(),
            searchBy: 'first_name',
            searchPlaceHolderText: 'Search by First Name',
            totalCost: '',
            clientsOnline: { online: 0, total: 0 },
         };
      },
      setUpdatePlanFormId(record) {
         this.submitted = false;
         this.formInputs.id = record.id;
         this.formInputs.subscription_period = record.subscription_period ? Number(record.subscription_period) : '';
         this.formInputs.subscription_package =
            this.planChoices.find(p => Number(p.id) === Number(record.subscription_package)) || null;
         this.$clearValidationStates('#updatePlanForm');
      },
      updatePlan() {
         this.$scrollToTopModal("planModal");
         this.submitted = true;
         const formIsValid = this.$validateForm('#updatePlanForm');
         if (!formIsValid) {
            this.$playErrorSound();
            this.handleAlert("starting", "Please correct the highlighted fields.", "danger", "modal");
            return;
         }

         this.handleAlert("starting", "Please wait submiting", "info", "modal");

         const packageId = this.formInputs.subscription_package?.id ?? '';

         let formData = new FormData();
         formData.append("id", this.formInputs.id);
         formData.append("subscription_package", packageId);
         formData.append("subscription_period", Number(packageId) === 0 ? 0 : this.formInputs.subscription_period);
         formData.append('action', 'updatePlan');

         axios.post(this.apiUrl, formData, this.$handleConfig())
            .then((response) => {
               if (response.data.status == 'success') {
                  this.handleUpdatePlanSuccess(response);
               } else {
                  const msg = response.data.message;
                  this.handleError("starting", Array.isArray(msg) ? msg[0] : msg, "danger", "modal");
               }
            })
            .catch((error) => {
               if (error.message === 'Network Error') {
                  this.handleAlert("ending", "No internet connection. Please check your network.", "danger", "modal");
               } else {
                  this.handleAlert("ending", "Something went wrong. Please try again later.", "danger", "modal");
               }
            });
      }  
   },
}; 
</script>